import React, { Component } from 'react';
import cn from 'classnames';
import css from './css.css';
import Tooltip from "./Tooltip";
import { HStack } from 'native-base';

export default class ElementTooltipContainer extends Component {
    tooltipRef = React.createRef(null);
    state = {
        showTooltip: true
    }

    componentDidMount() {
        this.setState({
            showTooltip: !!this.tooltipRef.current
        })
    }
    
    render() {
        let {children, className, tooltipClassName, tooltip, containerProps = {}, ...props} = this.props;

        return (
            <HStack space={ tooltip?.length ? 2 : 0 } { ...containerProps }>
                {children}
                {this.state.showTooltip && <Tooltip ref={this.tooltipRef} {...props} tooltip={tooltip} className={cn(tooltipClassName)} />}
            </HStack>
        )
    }
}